import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { usePortalAuth } from '../../context/PortalAuth';
import { INVOICES } from '../../data/portal';
import { requestDownloadUrl } from '../../lib/leads';
const STATUS_STYLES: Record<string, string> = {
  paid: 'bg-mist text-body',
  due: 'bg-champagne text-ink',
  overdue: 'bg-[#f7e7e7] text-[#8a2727]'
};
export function PortalInvoices() {
  const {
    user
  } = usePortalAuth();
  if (!user) return null;
  const invoices = INVOICES.filter(invoice => invoice.organisationId === user.organisationId);
  const outstanding = invoices.filter(invoice => invoice.status !== 'paid').reduce((sum, invoice) => sum + invoice.amount, 0);
  const download = async (fileName: string, number: string) => {
    const result = await requestDownloadUrl(fileName, {
      kind: 'invoice',
      id: number
    });
    if (!result.url) return;
    window.open(result.url, '_blank', 'noopener');
  };
  return <div className="space-y-8" data-id="element-990" data-mp="3q7431q4gjtoc">
      <header data-id="element-991" data-mp="3q7dwxosmikzb">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-992" data-mp="djswiai8dp04">Invoices</p>
        <h1 className="mt-3 font-display text-[30px] leading-tight text-ink sm:text-[36px]" data-id="element-993" data-mp="8l99e6rwi766">
          Billing for {user.organisationName}
        </h1>
        <p className="mt-2 text-[16px] text-body" data-id="element-994" data-mp="nbggxrgde5s3">
          Outstanding balance{' '}
          <span className="font-display text-[20px] text-royal" data-id="element-995" data-mp="iidmzi7okubd">${outstanding.toLocaleString('en-GB')}</span>
        </p>
      </header>

      <div className="overflow-x-auto rounded-md border border-line bg-white p-6" data-id="element-996" data-mp="wcmze62kxqnz">
        <table className="w-full min-w-[620px] border-collapse text-left" data-id="element-997" data-mp="s8p3034n2tym">
          <caption className="sr-only" data-id="element-998" data-mp="167ezphnjqrmg">Invoices raised to your organisation</caption>
          <thead data-id="element-999" data-mp="119di715rr0d3">
            <tr className="border-b border-line text-small uppercase tracking-[0.12em] text-muted" data-id="element-1000" data-mp="11aybkngckd9d">
              <th scope="col" className="py-3 pr-4 font-medium" data-id="element-1001" data-mp="380w7qmfl9uhq">Invoice</th>
              <th scope="col" className="py-3 pr-4 font-medium" data-id="element-1002" data-mp="331tbnrhl6ylw">Amount</th>
              <th scope="col" className="py-3 pr-4 font-medium" data-id="element-1003" data-mp="16y50qqp6hlvq">Status</th>
              <th scope="col" className="py-3 pr-4 font-medium" data-id="element-1004" data-mp="16zycgkenewal">Due</th>
              <th scope="col" className="py-3 font-medium" data-id="element-1005" data-mp="1bxhza8pewhe5">
                <span className="sr-only" data-id="element-1006" data-mp="1fy1wfc9zjl0a">Download</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line" data-id="element-1007" data-mp="1kxwmxepum8kt">
            {invoices.map(invoice => <tr key={invoice.id} data-id="element-1008" data-mp="1px99dyct5dmv">
                <td className="py-4 pr-4 text-[15px] text-ink" data-id="element-1009" data-mp="1pw7v7l0hwb0x">{invoice.number}</td>
                <td className="py-4 pr-4 text-[15px] text-ink" data-id="element-1010" data-mp="1uuj67z2j0rkq">
                  ${invoice.amount.toLocaleString('en-GB')} {invoice.currency}
                </td>
                <td className="py-4 pr-4" data-id="element-1011" data-mp="23nw65kz0ctgb">
                  <span className={`inline-block rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] ${STATUS_STYLES[invoice.status]}`} data-id="element-1012" data-mp="23nmfrwa1wka3">
                    {invoice.status === 'due' ? 'Due' : invoice.status === 'paid' ? 'Paid' : 'Overdue'}
                  </span>
                </td>
                <td className="py-4 pr-4 text-[14px] text-body" data-id="element-1013" data-mp="2irffr2n0oucs">
                  {new Date(invoice.dueDate).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
              })}
                </td>
                <td className="py-4" data-id="element-1014" data-mp="36gqjmsznz4v5">
                  <button type="button" onClick={() => void download(invoice.fileName, invoice.number)} className="inline-flex items-center gap-2 rounded-sm border border-royal/30 px-3.5 py-2 text-[14px] text-royal transition-colors hover:bg-mist" data-id="element-1015" data-mp="36foyfvoxp1zp">
                    <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-1016" data-mp="2sp3d80c0cfyn" />
                    PDF
                    <span className="sr-only" data-id="element-1017" data-mp="3p8j3nxwr9fqq">for invoice {invoice.number}</span>
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <p className="text-small text-muted" data-id="element-1018" data-mp="34x6vktbokffl">
        Payment is by bank transfer against the details on each invoice. Online payment will be added once a
        payment provider is connected.
      </p>
    </div>;
}